import { isNil } from "lodash";

import type { OptionType } from "@covertree/types";

export const formatCustomizationOptions = (
  options?: (number | string | OptionType<number | string>)[],
  min?: number,
  max?: number
): OptionType<number | string>[] => {
  if (!options)
    return !isNil(min) && !isNil(max)
      ? [
          { value: min, label: min.toString() },
          { value: max, label: max.toString() },
        ]
      : [];
  return options.map((opt) =>
    typeof opt === "object" ? opt : { value: opt, label: opt.toString() }
  );
};
